import { useEffect, useState } from 'react'

import { userPermissions } from '@/common/constants'
import useInventoryLocations from '@/common/hooks/useInventoryLocations/useInventoryLocations'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import useAccountPreferences from '@/general/pages/AccountPage/PreferencesConfiguration/hooks/useAccountPreferences/useAccountPreferences'
import { providers } from '@/returns/constants'

import { getDefaultRestockLocation } from './helpers'

const useRestock = (selectedStore, allowManageRestock, userId) => {
  const { hasPermission } = useUserPermissions()
  const hasRestockPermission = hasPermission(userPermissions.restockProducts, selectedStore?.id)
  const { inventoryLocations } = useInventoryLocations({ storeId: selectedStore?.id })

  const [restock, setRestock] = useState(
    allowManageRestock && hasRestockPermission ? selectedStore?.preferences?.manage_restock : false
  )
  const [restockLocation, setRestockLocation] = useState(null)
  const { defaultRestockLocation } = useAccountPreferences({
    storeId: selectedStore?.id,
    userId: userId,
  })

  useEffect(() => {
    setRestock(allowManageRestock && hasRestockPermission ? selectedStore?.preferences?.manage_restock : false)
    setRestockLocation(getDefaultRestockLocation(inventoryLocations, defaultRestockLocation))
  }, [selectedStore, allowManageRestock, defaultRestockLocation, hasRestockPermission, inventoryLocations])

  const restockIsValid = () => {
    if (restock) {
      if (selectedStore.provider === providers.shopify) {
        return restockLocation !== null
      }
    }

    return true
  }

  return {
    restock,
    setRestock,
    restockLocation,
    setRestockLocation,
    restockIsValid,
    inventoryLocations,
  }
}

export default useRestock
